import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { Flex, Icon } from '@haldor/ui';
import Person from '../UI/Elements/Person';
var MeetingUsers = /*#__PURE__*/function (_Component) {
  function MeetingUsers(props) {
    var _this;
    _classCallCheck(this, MeetingUsers);
    _this = _callSuper(this, MeetingUsers, [props]);
    _defineProperty(_this, "selectParticipant", function (user) {
      _this.props.onParticipantSelect(user);
    });
    _defineProperty(_this, "markForConversation", function (participant) {
      if (_this.props.onConversation != null) {
        _this.props.onConversation(participant);
      }
    });
    return _this;
  }
  _inherits(MeetingUsers, _Component);
  return _createClass(MeetingUsers, [{
    key: "hasNonStudentRole",
    value: function hasNonStudentRole(roles, referenceId) {
      return roles.some(function (role) {
        return role.referenceId === referenceId && role.roleId.toLowerCase() !== "student";
      });
    }
  }, {
    key: "renderUsers",
    value: function renderUsers() {
      var _this2 = this;
      var _this$props = this.props,
        users = _this$props.users,
        schoolId = _this$props.schoolId;
      return users.map(function (participant) {
        var user = participant.user;
        var conversation = null;
        if (_this2.props.conversations != null) {
          conversation = _this2.props.conversations.find(function (conv) {
            return conv.memberships.find(function (member) {
              return member.membershipID == user.id;
            });
          });
        }
        return /*#__PURE__*/React.createElement("div", {
          style: {
            margin: '0.55rem 0'
          },
          key: 'user-' + user.id
        }, /*#__PURE__*/React.createElement(Flex, {
          center: true
        }, /*#__PURE__*/React.createElement("div", {
          style: {
            flex: 1
          }
        }, /*#__PURE__*/React.createElement(Person, {
          person: user
        })), _this2.props.onConversation != null && _this2.props.user.id != user.id && participant.userType == "USER" && user.roles && _this2.hasNonStudentRole(user.roles, schoolId.toString()) ? /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Link, {
          to: "#",
          style: {
            cursor: 'pointer'
          },
          onClick: function onClick(e) {
            return _this2.markForConversation(user);
          }
        }, /*#__PURE__*/React.createElement("div", {
          style: {
            width: '1.75rem',
            position: 'relative',
            "float": 'right'
          }
        }, conversation != null ? /*#__PURE__*/React.createElement(Icon, {
          name: "message"
        }) : /*#__PURE__*/React.createElement(Icon, {
          name: "message",
          bw: true
        }), conversation != null && conversation.unreadMessages > 0 ? /*#__PURE__*/React.createElement("div", {
          className: "badge"
        }, /*#__PURE__*/React.createElement("span", null, conversation.unreadMessages)) : null))) : /*#__PURE__*/React.createElement("div", null)));
      });
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement("div", null, this.renderUsers());
    }
  }]);
}(Component);
function mapStateToProps(state) {
  return {
    user: state.User.user,
    conversations: state.Conversation.referenceConversations
  };
}
export default connect(mapStateToProps, {})(MeetingUsers);